export default function (Component) {
  Component.__i18n = Component.__i18n || []
  Component.__i18n.push({
    "locale": "",
    "resource": {
      "en": {
        "close-sidebar": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Close sidebar"])},
        "logo": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Tomat logo"])},
        "support": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Help and support"])},
        "support-link": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["https://info.allotomat.com/user-guide/"])}
      },
      "fr": {
        "close-sidebar": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Fermer le panneau"])},
        "logo": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Logo de Tomat"])},
        "support": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Aide et support"])},
        "support-link": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["https://info.allotomat.com/guide-dutilisation/"])}
      }
    }
  })
}
